import React, { useContext } from 'react';
import { CPProgressContext } from '../../hooks/CPProgress/context';
import { DeploymentEvaluator } from 'cccisd-laravel-assignment';

function WrappedDeploymentEvaluator(props) {
    const cpProgress = useContext(CPProgressContext);

    return (
        <DeploymentEvaluator
            {...props}
            onFlowComplete={cpProgress.refetchData}
            {...(cpProgress.isBaselineDone
                ? {
                      flowProps: {
                          variables: cpProgress.flowVariables,
                      },
                  }
                : {})}
        />
    );
}

export default WrappedDeploymentEvaluator;
